import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/presence`;

const sessionId = () => {
  let id = sessionStorage.getItem("sleep-site-visitor");
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("sleep-site-visitor", id);
  }
  return id;
};

export const VisitorCount = () => {
  const [count, setCount] = useState(null);
  useEffect(() => {
    const id = sessionId();
    const ping = () => fetch(`${API}/ping`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id }) })
      .then((r) => r.json()).then((j) => setCount(j.count)).catch(() => {});
    ping();
    const t = setInterval(ping, 20000);
    return () => clearInterval(t);
  }, []);
  if (!count) return null;
  return (
    <p className="visitor-count" data-testid="visitor-count">
      <span className="vc-dot" aria-hidden="true" />
      <span data-testid="visitor-count-number">{count}</span> sleepless {count === 1 ? "soul" : "souls"} here now
    </p>
  );
};
